var _excluded = ["height", "minHeight", "maxHeight", "backgroundColor", "borderBottomColor", "borderBottomEndRadius", "borderBottomLeftRadius", "borderBottomRightRadius", "borderBottomStartRadius", "borderBottomWidth", "borderColor", "borderEndColor", "borderEndWidth", "borderLeftColor", "borderLeftWidth", "borderRadius", "borderRightColor", "borderRightWidth", "borderStartColor", "borderStartWidth", "borderStyle", "borderTopColor", "borderTopEndRadius", "borderTopLeftRadius", "borderTopRightRadius", "borderTopStartRadius", "borderTopWidth", "borderWidth", "boxShadow", "elevation", "shadowColor", "shadowOffset", "shadowOpacity", "shadowRadius", "opacity", "transform"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { Animated, Platform, StyleSheet, View } from "react-native-web";
import { useSafeAreaFrame, useSafeAreaInsets } from 'react-native-safe-area-context';
import getDefaultHeaderHeight from "./getDefaultHeaderHeight";
import HeaderBackground from "./HeaderBackground";
import HeaderShownContext from "./HeaderShownContext";
import HeaderTitle from "./HeaderTitle";
var warnIfHeaderStylesDefined = function warnIfHeaderStylesDefined(styles) {
  Object.keys(styles).forEach(function (styleProp) {
    var value = styles[styleProp];
    if (styleProp === 'position' && value === 'absolute') {
      console.warn("position: 'absolute' is not supported on headerStyle. If you would like to render content under the header, use the 'headerTransparent' option.");
    } else if (value !== undefined) {
      console.warn("".concat(styleProp, " was given a value of ").concat(value, ", this has no effect on headerStyle."));
    }
  });
};
export default function Header(props) {
  var insets = useSafeAreaInsets();
  var frame = useSafeAreaFrame();
  var isParentHeaderShown = React.useContext(HeaderShownContext);

  // On models with Dynamic Island the status bar height is smaller than the safe area top inset.
  var hasDynamicIsland = Platform.OS === 'ios' && insets.top > 50;
  var statusBarHeight = hasDynamicIsland ? insets.top - 5 : insets.top;
  var _props$layout = props.layout,
    layout = _props$layout === void 0 ? frame : _props$layout,
    _props$modal = props.modal,
    modal = _props$modal === void 0 ? false : _props$modal,
    title = props.title,
    customTitle = props.headerTitle,
    _props$headerTitleAli = props.headerTitleAlign,
    headerTitleAlign = _props$headerTitleAli === void 0 ? Platform.select({
      ios: 'center',
      "default": 'left'
    }) : _props$headerTitleAli,
    headerLeft = props.headerLeft,
    headerLeftLabelVisible = props.headerLeftLabelVisible,
    headerTransparent = props.headerTransparent,
    headerTintColor = props.headerTintColor,
    headerBackground = props.headerBackground,
    headerRight = props.headerRight,
    titleAllowFontScaling = props.headerTitleAllowFontScaling,
    titleStyle = props.headerTitleStyle,
    leftContainerStyle = props.headerLeftContainerStyle,
    rightContainerStyle = props.headerRightContainerStyle,
    titleContainerStyle = props.headerTitleContainerStyle,
    backgroundContainerStyle = props.headerBackgroundContainerStyle,
    customHeaderStyle = props.headerStyle,
    headerShadowVisible = props.headerShadowVisible,
    headerPressColor = props.headerPressColor,
    headerPressOpacity = props.headerPressOpacity,
    _props$headerStatusBa = props.headerStatusBarHeight,
    headerStatusBarHeight = _props$headerStatusBa === void 0 ? isParentHeaderShown ? 0 : statusBarHeight : _props$headerStatusBa;
  var defaultHeight = getDefaultHeaderHeight(layout, modal, headerStatusBarHeight);
  var _StyleSheet$flatten = StyleSheet.flatten(customHeaderStyle || {}),
    _StyleSheet$flatten$h = _StyleSheet$flatten.height,
    height = _StyleSheet$flatten$h === void 0 ? defaultHeight : _StyleSheet$flatten$h,
    minHeight = _StyleSheet$flatten.minHeight,
    maxHeight = _StyleSheet$flatten.maxHeight,
    backgroundColor = _StyleSheet$flatten.backgroundColor,
    borderBottomColor = _StyleSheet$flatten.borderBottomColor,
    borderBottomEndRadius = _StyleSheet$flatten.borderBottomEndRadius,
    borderBottomLeftRadius = _StyleSheet$flatten.borderBottomLeftRadius,
    borderBottomRightRadius = _StyleSheet$flatten.borderBottomRightRadius,
    borderBottomStartRadius = _StyleSheet$flatten.borderBottomStartRadius,
    borderBottomWidth = _StyleSheet$flatten.borderBottomWidth,
    borderColor = _StyleSheet$flatten.borderColor,
    borderEndColor = _StyleSheet$flatten.borderEndColor,
    borderEndWidth = _StyleSheet$flatten.borderEndWidth,
    borderLeftColor = _StyleSheet$flatten.borderLeftColor,
    borderLeftWidth = _StyleSheet$flatten.borderLeftWidth,
    borderRadius = _StyleSheet$flatten.borderRadius,
    borderRightColor = _StyleSheet$flatten.borderRightColor,
    borderRightWidth = _StyleSheet$flatten.borderRightWidth,
    borderStartColor = _StyleSheet$flatten.borderStartColor,
    borderStartWidth = _StyleSheet$flatten.borderStartWidth,
    borderStyle = _StyleSheet$flatten.borderStyle,
    borderTopColor = _StyleSheet$flatten.borderTopColor,
    borderTopEndRadius = _StyleSheet$flatten.borderTopEndRadius,
    borderTopLeftRadius = _StyleSheet$flatten.borderTopLeftRadius,
    borderTopRightRadius = _StyleSheet$flatten.borderTopRightRadius,
    borderTopStartRadius = _StyleSheet$flatten.borderTopStartRadius,
    borderTopWidth = _StyleSheet$flatten.borderTopWidth,
    borderWidth = _StyleSheet$flatten.borderWidth,
    boxShadow = _StyleSheet$flatten.boxShadow,
    elevation = _StyleSheet$flatten.elevation,
    shadowColor = _StyleSheet$flatten.shadowColor,
    shadowOffset = _StyleSheet$flatten.shadowOffset,
    shadowOpacity = _StyleSheet$flatten.shadowOpacity,
    shadowRadius = _StyleSheet$flatten.shadowRadius,
    opacity = _StyleSheet$flatten.opacity,
    transform = _StyleSheet$flatten.transform,
    unsafeStyles = _objectWithoutProperties(_StyleSheet$flatten, _excluded);
  if (process.env.NODE_ENV !== 'production') {
    warnIfHeaderStylesDefined(unsafeStyles);
  }
  var safeStyles = {
    backgroundColor: backgroundColor,
    borderBottomColor: borderBottomColor,
    borderBottomEndRadius: borderBottomEndRadius,
    borderBottomLeftRadius: borderBottomLeftRadius,
    borderBottomRightRadius: borderBottomRightRadius,
    borderBottomStartRadius: borderBottomStartRadius,
    borderBottomWidth: borderBottomWidth,
    borderColor: borderColor,
    borderEndColor: borderEndColor,
    borderEndWidth: borderEndWidth,
    borderLeftColor: borderLeftColor,
    borderLeftWidth: borderLeftWidth,
    borderRadius: borderRadius,
    borderRightColor: borderRightColor,
    borderRightWidth: borderRightWidth,
    borderStartColor: borderStartColor,
    borderStartWidth: borderStartWidth,
    borderStyle: borderStyle,
    borderTopColor: borderTopColor,
    borderTopEndRadius: borderTopEndRadius,
    borderTopLeftRadius: borderTopLeftRadius,
    borderTopRightRadius: borderTopRightRadius,
    borderTopStartRadius: borderTopStartRadius,
    borderTopWidth: borderTopWidth,
    borderWidth: borderWidth,
    // @ts-expect-error: boxShadow is only for Web
    boxShadow: boxShadow,
    elevation: elevation,
    shadowColor: shadowColor,
    shadowOffset: shadowOffset,
    shadowOpacity: shadowOpacity,
    shadowRadius: shadowRadius,
    opacity: opacity,
    transform: transform
  };

  // Setting a property to undefined triggers default style
  // So we need to filter them out
  // Users can use `null` instead
  for (var styleProp in safeStyles) {
    // @ts-expect-error: typescript wrongly complains that styleProp cannot be used to index safeStyles
    if (safeStyles[styleProp] === undefined) {
      // @ts-expect-error
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete safeStyles[styleProp];
    }
  }
  var backgroundStyle = [safeStyles, headerShadowVisible === false && {
    elevation: 0,
    shadowOpacity: 0,
    borderBottomWidth: 0
  }];
  var leftButton = headerLeft ? headerLeft({
    tintColor: headerTintColor,
    pressColor: headerPressColor,
    pressOpacity: headerPressOpacity,
    labelVisible: headerLeftLabelVisible
  }) : null;
  var rightButton = headerRight ? headerRight({
    tintColor: headerTintColor,
    pressColor: headerPressColor,
    pressOpacity: headerPressOpacity
  }) : null;
  var headerTitle = typeof customTitle !== 'function' ? function (props) {
    return /*#__PURE__*/React.createElement(HeaderTitle, props);
  } : customTitle;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Animated.View, {
    pointerEvents: "box-none",
    style: [StyleSheet.absoluteFill, {
      zIndex: 0
    }, backgroundContainerStyle]
  }, headerBackground ? headerBackground({
    style: backgroundStyle
  }) : headerTransparent ? null : /*#__PURE__*/React.createElement(HeaderBackground, {
    style: backgroundStyle
  })), /*#__PURE__*/React.createElement(Animated.View, {
    pointerEvents: "box-none",
    style: [{
      height: height,
      minHeight: minHeight,
      maxHeight: maxHeight,
      opacity: opacity,
      transform: transform
    }]
  }, /*#__PURE__*/React.createElement(View, {
    pointerEvents: "none",
    style: {
      height: headerStatusBarHeight
    }
  }), /*#__PURE__*/React.createElement(View, {
    pointerEvents: "box-none",
    style: styles.content
  }, /*#__PURE__*/React.createElement(Animated.View, {
    pointerEvents: "box-none",
    style: [styles.left, headerTitleAlign === 'center' && styles.expand, {
      marginStart: insets.left
    }, leftContainerStyle]
  }, leftButton), /*#__PURE__*/React.createElement(Animated.View, {
    pointerEvents: "box-none",
    style: [styles.title, {
      // Avoid the title from going offscreen or overlapping buttons
      maxWidth: headerTitleAlign === 'center' ? layout.width - ((leftButton ? headerLeftLabelVisible !== false ? 80 : 32 : 16) + Math.max(insets.left, insets.right)) * 2 : layout.width - ((leftButton ? 72 : 16) + (rightButton ? 72 : 16) + insets.left - insets.right)
    }, titleContainerStyle]
  }, headerTitle({
    children: title,
    allowFontScaling: titleAllowFontScaling,
    tintColor: headerTintColor,
    style: titleStyle
  })), /*#__PURE__*/React.createElement(Animated.View, {
    pointerEvents: "box-none",
    style: [styles.right, styles.expand, {
      marginEnd: insets.right
    }, rightContainerStyle]
  }, rightButton))));
}
var styles = StyleSheet.create({
  content: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'stretch'
  },
  title: {
    marginHorizontal: 16,
    justifyContent: 'center'
  },
  left: {
    justifyContent: 'center',
    alignItems: 'flex-start'
  },
  right: {
    justifyContent: 'center',
    alignItems: 'flex-end'
  },
  expand: {
    flexGrow: 1,
    flexBasis: 0
  }
});